import React, { useState, useEffect } from "react";
import LastChangesTabs from "./LastChangesTabs";

const LastChangesModal = ({
  isOpen,
  onClose,
  lastChanges,
  setLastChanges,
  lastChangesInfo,
  getFieldChanges,
  fieldChangesInfo,
  setLastChangesInfo,
  setFieldChangesInfo,
}) => {
  const [fieldNameSelected, setFieldNameSelected] = useState("");
  const [nameFieldTab, setNameFieldTab] = useState("Field Changes");
  const [lastChangesRowSelected, setLastChangesRowSelected] = useState(0);

  useEffect(() => {
    if (lastChangesInfo.length > 0) {
      setFieldNameSelected(lastChangesInfo[0].fieldname);
    }
  }, [lastChangesInfo]);

  const renderHeader = (
    headerName,
    fieldName,
    headerName2 = "",
    fieldName2 = ""
  ) => (
    <div className="mt-2 text-center">
      <p
        className="lead text-muted"
        style={{ fontSize: "20px", margin: "2px" }}
      >
        {headerName}:{" "}
        <span
          className="text-info font-weight-bold"
          style={{ fontSize: "22px" }}
        >
          {fieldName}
        </span>
        {headerName2 && (
          <>
            {" "}
            - {headerName2}:{" "}
            <span
              className="text-info font-weight-bold"
              style={{ fontSize: "22px" }}
            >
              {fieldName2}
            </span>
          </>
        )}
      </p>
    </div>
  );

  const getModalHeaderAndTitle = () => {
    if (!lastChanges) return { header: "", title: "" };

    const { TableName, HeaderName1, HeaderName2 } = lastChanges;

    switch (TableName) {
      case "LIMITSETTRACKCATEGORYLOG":
        return {
          header: renderHeader("Profile", HeaderName1, "Category", HeaderName2),
          title: `${HeaderName1} - ${HeaderName2}`,
        };
      case "LIMITSETLOG":
        return {
          header: renderHeader("LimitSet", HeaderName1),
          title: HeaderName1,
        };
      case "LIMITSETBETTYPELOG":
        return {
          header: renderHeader("LimitSet", HeaderName1, "BetType", HeaderName2),
          title: `${HeaderName1} - ${HeaderName2}`,
        };
      case "TRACKLOG":
        return {
          header: renderHeader("Track Name", HeaderName1),
          title: HeaderName1,
        };
      case "TRACKBYBOOKLOG":
        return {
          header: renderHeader("Book Name", HeaderName1),
          title: HeaderName1,
        };
      case "PROFILETRACKENABLELOG":
        return {
          header: renderHeader("Profile Name", HeaderName1),
          title: HeaderName1,
        };
      default:
        return { header: "", title: "" };
    }
  };

  const closeLastChangesModal = () => {
    try {
      document.getElementById("lastChanges-tab")?.classList.add("active");
      document.getElementById("fieldChanges-tab")?.classList.remove("active");
      document
        .getElementById("fieldChanges")
        ?.classList.remove("active", "show");
      document.getElementById("lastChanges")?.classList.add("active", "show");
    } catch (e) {
      // Safe fallback
    }

    setLastChanges({
      ChangeType: "",
      Param1: "",
      Param2: "",
      ProfileName: "",
      CategoryName: "",
      BetTypeName: "",
      LimitSetName: "",
      BookName: "",
    });

    setLastChangesInfo([]);
    setFieldChangesInfo([]);
    setFieldNameSelected("");
    setNameFieldTab("Field Changes");
    setLastChangesRowSelected(0);

    onClose(); // Close the modal from parent
  };

  const { header, title } = getModalHeaderAndTitle();

  if (!isOpen) return null;

  return (
    <div
      className="modal d-block show"
      role="dialog"
      aria-modal="true"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1051,
      }}
    >
      <div className="modal-dialog modal-md" style={{ margin: "4rem auto" }}>
        <div className="modal-content">
          <div
            className="modal-header"
            style={{ backgroundColor: "#5b6671", color: "#fff" }}
          >
            <h5 className="modal-title">Last Changes in {title}</h5>
            <button
              type="button"
              className="close"
              onClick={closeLastChangesModal}
            >
              &times;
            </button>
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-sm-12">
                {header}
                <LastChangesTabs
                  lastChangesInfo={lastChangesInfo}
                  fieldNameSelected={fieldNameSelected}
                  setFieldNameSelected={setFieldNameSelected}
                  getFieldChanges={getFieldChanges}
                  fieldChangesInfo={fieldChangesInfo}
                  nameFieldTab={nameFieldTab}
                  setNameFieldTab={setNameFieldTab}
                  lastChangesRowSelected={lastChangesRowSelected}
                  setLastChangesRowSelected={setLastChangesRowSelected}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeLastChangesModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastChangesModal;
